import gql from 'graphql-tag'

export default gql`mutation ($data: NotificationInput!){
  upsertNotification(data: $data){
    id
    subject
    message
    user{
      user_id
      first_name
      last_name
    }
    popup
    updated_at
  }
}`